export default __webpack_public_path__ + "static/media/service_mockup1.c489e1d8.png";